'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/intl-messageformat-parser/index.js
 **/